/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_MaskedInputs */

const tr_privacy_masked = /** @type {(inputs: Privacy_MaskedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gizli`)
};

const en_privacy_masked = /** @type {(inputs: Privacy_MaskedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hidden`)
};

const de_privacy_masked = /** @type {(inputs: Privacy_MaskedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verborgen`)
};

const ru_privacy_masked = /** @type {(inputs: Privacy_MaskedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скрыто`)
};

/**
* | output |
* | --- |
* | "Hidden" |
*
* @param {Privacy_MaskedInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const privacy_masked = /** @type {((inputs?: Privacy_MaskedInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_MaskedInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_privacy_masked(inputs)
	if (locale === "de") return de_privacy_masked(inputs)
	if (locale === "ru") return ru_privacy_masked(inputs)
	return tr_privacy_masked(inputs)
});